import { ProviderTaskType } from '@lyrahealth-inc/shared-app-logic/src/models/providers/Providers'

import { baseApi, RTKQueryTag } from '../../../data/baseApi'

export type TslLetterDetail = {
  id: string
  requesterLyraId: string
  providerLyraId: string
  providerDisplayName: string
  startDate: string | null
  endDate: string | null
  episodeIds: string[]
  sessionCount: number
  treatmentCodes: string[]
  draftText: string
  anticipatedGraduation: string | null
  estimatedCompletionDate: string | null
  status: 'awaiting_provider' | 'completed'
  documentId: string | null
  ppapiTaskId: string | null
  completedAt: string | null
}

type PatchTslLetterPayload = {
  id: string
  data: { draftText: string }
}

const tslApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTslLetter: builder.query<TslLetterDetail, string>({
      query: (letterId) => ({
        method: 'get',
        url: `/lt/v1/treatment-summary-letters/${letterId}`,
      }),
      providesTags: (_result, _error, letterId) => [{ type: RTKQueryTag.TSL_LETTER, id: letterId }],
    }),
    patchTslLetter: builder.mutation<TslLetterDetail, PatchTslLetterPayload>({
      query: ({ id, data }) => ({
        method: 'patch',
        url: `/lt/v1/treatment-summary-letters/${id}`,
        data,
      }),
      // Cache the saved letter so a failed refetch can't show the pre-save draft
      onQueryStarted: async ({ id }, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled
          dispatch(tslApi.util.updateQueryData('getTslLetter', id, () => data))
        } catch {
          // Save errors are handled by the caller
        }
      },
      invalidatesTags: (_result, _error, arg) => [{ type: RTKQueryTag.TSL_LETTER, id: arg.id }],
    }),
    approveTslLetter: builder.mutation<TslLetterDetail, string>({
      query: (letterId) => ({
        method: 'post',
        url: `/lt/v1/treatment-summary-letters/${letterId}/approve`,
        showAlert: false,
      }),
      onQueryStarted: async (letterId, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled
          dispatch(tslApi.util.updateQueryData('getTslLetter', letterId, () => data))
        } catch {
          // Approval errors are handled by the caller
        }
      },
      invalidatesTags: (_result, _error, letterId) => [
        { type: RTKQueryTag.TSL_LETTER, id: letterId },
        { type: RTKQueryTag.PROVIDER_TASK, id: ProviderTaskType.TREATMENT_SUMMARY_LETTER },
      ],
    }),
  }),
})

export const { useGetTslLetterQuery, usePatchTslLetterMutation, useApproveTslLetterMutation } = tslApi
